// extracted by mini-css-extract-plugin
export default {"skeleton-placeholder":"aGbib","skeletonPlaceholder":"aGbib","appear-from-above":"RmkUf","appearFromAbove":"RmkUf"};